import React from 'react';
import { Link } from 'react-router';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

const SideNav = ({ page, spaceID, intl, linkPrefix, urlSection, pagesCollection, heading }) => {
  return (
    <>
      <h5>{heading}</h5>
      {
        pagesCollection.map((val = {}) => {
          const { page: pageValue = '', icon: Icon } = val;

          if (pageValue === page) {
            return (
              <div className="margin-lg-top flex middle heavier" key={pageValue}>
                {
                  val.icon &&
                  <div className="margin-md-right">
                    <Icon className="flex" style={{ fontSize: '24px' }} />
                  </div>
                }
                <div style={{ paddingTop: '4px' }}>
                  {intl.formatMessage(val.label)}
                </div>
              </div>
            );
          }
          return (
            <div key={pageValue} className="margin-lg-top heavier">
              <Link
                className="link-gray-dark flex middle"
                key={pageValue}
                to={`${linkPrefix}/${spaceID}${urlSection ? `/${urlSection}` : ''}/${pageValue}`}
                onlyActiveOnIndex
              >
                {
                  val.icon &&
                  <div className="margin-md-right">
                    <Icon className="flex" style={{ fontSize: '24px' }} />
                  </div>
                }
                <div style={{ paddingTop: '4px' }}>
                  {intl.formatMessage(val.label)}
                </div>
              </Link>
            </div>
          );
        })
      }
    </>
  );
};

SideNav.propTypes = {
  page: PropTypes.string,
  spaceID: PropTypes.string,
  intl: PropTypes.object,
  linkPrefix: PropTypes.string,
  urlSection: PropTypes.string,
  pagesCollection: PropTypes.array,
  heading: PropTypes.string
};

export default injectIntl(SideNav);
